import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
// import { ParallaxPlanet } from 'sections/Events/components/ParallaxPlanet';
import { Video } from 'sections/Events/AnnualConference/components/Video/';
import styles from 'sections/Events/AnnualConference/components/SectionArticles/SectionArticles.module.scss';

const cn = classNames.bind(styles);

const SectionArticles = (): ReactElement => {
  return (
    <section className={cn('articles')}>
      <div className={cn('container')}>
        <div className={cn('articles__content')}>
          <div className={cn('articles__description')}>
            <p className={cn('articles__description-title')}>description</p>
            <div className={cn('articles__description-content')}>
              <p className={cn('articles__description-text')}>
                We are pleased to have hosted the first physical meeting for our freight forwarding membership
                network, the Digital Freight Alliance (DFA). In March, the DP World FLOW Pavilion - Expo 2020 played
                host to 34 freight forwarding and logistics companies from 12 countries.
              </p>
              <p className={cn('articles__description-text')}>
                The conference offered a valuable opportunity for DFA members to meet and network, as well as hear
                from DP World as it presented its vision for the future of digital freight forwarding.
              </p>
              <p className={cn('articles__description-text')}>
                At a time when small-to-medium freight forwarders have navigated the challenges of turbulent supply
                chains, the annual members event offered an opportunity to explore how the DFA may help improve ocean
                freight procurement. Panel sessions included discussions on the move from physical to digital freight
                forwarding solutions and exploring the possibilities of container provision. A number of
                demonstrations took place, including sessions on CARGOES Finance, CARGOES Runner, DUBUY.com and
                SeaRates software.
              </p>
              <p className={cn('articles__description-text')}>
                <span className={cn('articles__description-text', 'bold')}>
                  Mike Bhaskaran, Chief Operating Officer of Digital Technology, DP World
                </span>
                , said: “DP World believes that digital transformation is the future of freight forwarding. Providing
                digital solutions to the widest possible number of SME independent forwarders is good for trade and
                economic growth. The aspiration is that DFA membership will exceed 5,000 by the end of 2022, and that
                there will be increasing engagement both between members, on the SeaRates.com booking platform, and
                also on policy formulation to help our membership navigate supply chain challenges.”
              </p>
              <p className={cn('articles__description-text')}>
                In a post-event survey, 86% of attendees noted they had enjoyed the event, with 109 new members
                joining the DFA in the week following the event. The annual members meeting follows the recent news
                that there are now over 3,000 members of the DFA. This represents substantial growth, from 1,100
                members at the start of 2021, to 2,500 by the end of 2021, to 3,300 today.
              </p>
            </div>
          </div>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'VideoObject',
                name: 'Digital Freight Alliance: Logistics Network for Global Freight',
                description:
                  'Digital Freight Alliance is a leading Online Logistics Network & Member Portal. Enroll with us and get unique features of our Membership Plan',
                thumbnailUrl: ['https://www.df-alliance.com/images/pages/Events/AnnualConference/player-bg.png'],
                uploadDate: '2024-03-01T08:00:00+08:00',
                duration: 'PT00H00M40S',
                contentUrl: 'https://www.df-alliance.com/video/pages/Events/AnnualConference/video.mp4',
              }),
            }}
          />

          <Video
            image="/images/pages/Events/AnnualConference/player-bg.png"
            video="/video/pages/Events/AnnualConference/video.mp4"
          />

          {/* <ParallaxPlanet /> */}

          <div className={cn('articles__content-icons-box')}>
            <ul className={cn('articles__content-icons')}>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-planet.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>Worldwide attendees</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-diamond.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>First-class organization</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-comment-cloud.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>1-on-1 meetings</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-circle.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>EXPO tour</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-suitcase.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>Workshop</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-ellipsis.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>Much more</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionArticles;